import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { CoreBadgeType } from '../../coreBadge/types';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import { ThemeContext, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { usePushModal } from '../../utils/hooks/usePushModal';
import { ModalType } from '../../Modals/redux/types';
import { useCustomNotifications } from '../../Notifications/CustomNotificationContext';
import { NotificationType } from '../../Notifications';
import ConditionalWrapper from '../../ConditionalWrapper';
import { badgeNotificationsFilter } from '../utils';
import s from './CoreBadgeButton.scss';
function getTooltipHeaderTranslation(type) {
    switch(type){
        case CoreBadgeType.DIAMOND:
            return 'coreBadge.tooltip.diamond.header';
        case CoreBadgeType.EMERALD:
            return 'coreBadge.tooltip.emerald.header';
        case CoreBadgeType.GLASS:
            return 'coreBadge.tooltip.glass.header';
        default:
            return '';
    }
}
function getTooltipDescriptionTranslation(type) {
    switch(type){
        case CoreBadgeType.DIAMOND:
            return 'coreBadge.tooltip.diamond.description';
        case CoreBadgeType.EMERALD:
            return 'coreBadge.tooltip.emerald.description';
        case CoreBadgeType.GLASS:
            return 'coreBadge.tooltip.glass.description';
        default:
            return '';
    }
}
function getTooltipIconUrl(type) {
    switch(type){
        case CoreBadgeType.DIAMOND:
            return Url.staticCDNLink('eclipse/global/images/diamond-sm.png');
        case CoreBadgeType.EMERALD:
            return Url.staticCDNLink('eclipse/global/images/emerald-sm.png');
        case CoreBadgeType.GLASS:
            return Url.staticCDNLink('eclipse/global/images/quartz-sm.png');
        default:
            return '';
    }
}
const CoreBadgeButton = ({ type , recipient , targetTypeId , targetItemId , badges , className , children , biData , hideTooltip  })=>{
    const { t  } = useTranslation();
    const { notifications  } = useCustomNotifications([
        NotificationType.Badge
    ]);
    const hasNotification = notifications.some(badgeNotificationsFilter(type));
    const reverseTheme = useContext(ThemeContext) === ThemeOptions.LIGHT ? ThemeOptions.DARK : ThemeOptions.LIGHT;
    const pushAwardsModal = usePushModal(ModalType.RECEIVED_AWARDS);
    return /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: !hideTooltip && [
            CoreBadgeType.GLASS,
            CoreBadgeType.EMERALD,
            CoreBadgeType.DIAMOND
        ].includes(type),
        wrap: (child)=>/*#__PURE__*/ React.createElement(SophisticatedTooltip, {
                isVisible: hasNotification ? false : undefined,
                heading: t(getTooltipHeaderTranslation(type)),
                description: t(getTooltipDescriptionTranslation(type)),
                placement: 'top',
                forceTheme: reverseTheme,
                usePortal: true,
                prefix: /*#__PURE__*/ React.createElement("img", {
                    src: getTooltipIconUrl(type),
                    className: s['badge-icon'],
                    width: 56,
                    height: 56,
                    alt: type
                }),
                width: 345,
                postfix: /*#__PURE__*/ React.createElement(SophisticatedTooltipLink, {
                    href: "https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments",
                    target: "_blank",
                    rel: "noreferrer"
                }, t('coreBadge.tooltip.learn')),
                size: 'medium'
            }, child)
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: c(s['toggle'], className),
        onClick: ()=>pushAwardsModal({
                badges,
                recipient,
                defaultActiveType: type,
                typeId: targetTypeId,
                itemId: targetItemId
            }),
        biData: biData
    }, children));
};
CoreBadgeButton.displayName = 'CoreBadgeButton';
export default CoreBadgeButton;
